import React from 'react';
import PropTypes from 'prop-types';

import { useHeaderContext } from '@context';
import { StyledLogoLink, StyledLogoText } from './styled';

const Logo = ({ className }) => {
  const { platformBaseUrl } = useHeaderContext();

  return (
    <StyledLogoLink
      href={`${platformBaseUrl}/`}
      data-qa="logoHomeCta"
      className={className}
    >
      <StyledLogoText>ManoMano</StyledLogoText>
    </StyledLogoLink>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: null,
};

Logo.displayName = 'Logo';

export default Logo;
